import React, {useState} from "react"
import "./index.scss"
import { OUR_EXPERTS, OUR_MANAGMENT } from "../../data/about-us/people"
import { PeopleCard } from "../people-card"
import { useMediaQuery } from "react-responsive"
import { DESKTOP_WIDTH } from "../../constants/common"
import PlusIcon from "../../components/icons/PlusIcon"
import MinusIcon from "../../components/icons/MinusIcon"

export const NewsoftPeople = () => {
    const isDesktop = useMediaQuery({ minWidth: DESKTOP_WIDTH })
    const [showMoreManagement, setShowMoreManagement] = useState(false)
    const [showMoreExperts, setShowMoreExperts] = useState(false)

    const [visibleItemsManagement, setVisibleItemsManagement] = useState(3)
    const [visibleItemsExperts, setVisibleItemsExperts] = useState(3)

    return (
        <div className="newsoft-people-wrapper">
            <div className="newsoft-people">
                <h1 className="t-h1-m">Newsoft people</h1>
                <div className="newsoft-people-block">
                    <h2 className="t-s3">Our management</h2>
                    {isDesktop ?
                        <div className="newsoft-people-list">
                            {OUR_MANAGMENT.map((person) => (
                                <PeopleCard key={person.image} {...person} />
                            ))}
                        </div> :
                        <div className="newsoft-people-list">
                            {OUR_MANAGMENT.slice(0, visibleItemsManagement).map((person, id) => (
                                <>
                                    <PeopleCard key={id} {...person} />
                                    {id >= visibleItemsManagement-1 && !showMoreManagement && (
                                        <h6 className="newsoft-people-nav t-nav" onClick={() => {setShowMoreManagement(true); setVisibleItemsManagement(OUR_MANAGMENT.length)}}>
              LEARN MORE <PlusIcon color="black" />
                                        </h6>)}
                                    { id=== OUR_MANAGMENT.length-1 && showMoreManagement && (
                                        <h6 className="newsoft-people-nav t-nav" onClick={() => {setShowMoreManagement(false); setVisibleItemsManagement(3)}}>
              COLLAPSE <MinusIcon color="black" />
                                        </h6>
                                    )}
                                </>
                                         
                            ))}
                        </div> }
                </div>
                <div className="newsoft-people-reverse">
                    <h2 className="t-s3">Our experts</h2>
                    <div className="newsoft-people-list">
                        {isDesktop ?
                            <div className="newsoft-people-list">
                                {OUR_EXPERTS.map((person) => (
                                    <PeopleCard key={person.image} {...person} />
                                ))}
                            </div> :
                            <div className="newsoft-people-list">
                                {OUR_EXPERTS.slice(0, visibleItemsExperts).map((person, id) => (
                                    <>
                                        <PeopleCard key={id} {...person} />
                                        {id >= visibleItemsExperts-1 && !showMoreExperts && (
                                            <h6 className="newsoft-people-nav t-nav" onClick={() => {setShowMoreExperts(true); setVisibleItemsExperts(OUR_EXPERTS.length)}}>
              LEARN MORE <PlusIcon color="black" />
                                            </h6>)}
                                        { id=== OUR_EXPERTS.length-1 && showMoreExperts && (
                                            <h6 className="newsoft-people-nav t-nav" onClick={() => {setShowMoreExperts(false); setVisibleItemsExperts(3)}}>
              COLLAPSE <MinusIcon color="black" />
                                            </h6>
                                        )}
                                    </>
                                         
                                ))}
                            </div> }
                    </div>
                </div>
            </div>
        </div>
    )
}
